import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MmDialogData, MmDialogRefService } from '@metromarkets/components';

import { ConfirmDialogData } from '../../models';

@Component({
  selector: 'app-order-confirm-dialog',
  templateUrl: './order-confirm-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderConfirmDialogComponent {
  constructor(@Inject(MmDialogData) public data: ConfirmDialogData,
              public dialogRef: MmDialogRefService<OrderConfirmDialogComponent>) {
  }
}
